<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4142 5L18.9999 7.58578L19.2928 7.29289C20.0069 6.57885 20.0069 5.42115 19.2928 4.7071C18.5788 3.99306 17.4211 3.99306 16.7071 4.7071L16.4142 5ZM14.9999 6.41421L4.92115 16.493L4.2747 19.7252L7.50693 19.0788L17.5857 9L14.9999 6.41421ZM20.7071 8.7071L8.70705 20.7071C8.56745 20.8467 8.38965 20.9419 8.19606 20.9806L3.19606 21.9806C2.49634 22.1205 1.87942 21.5036 2.01936 20.8039L3.01936 15.8039C3.05808 15.6103 3.15324 15.4325 3.29284 15.2929L15.2928 3.29289C16.7879 1.7978 19.212 1.7978 20.7071 3.29289C22.2021 4.78798 22.2021 7.21201 20.7071 8.7071Z"
      fill="currentColor"
    />
  </svg>
</template>
